<h2 mat-dialog-title class="text-lg font-bold mb-4">
  {{data.frequencies.name}}
</h2>

<mat-dialog-content class="modal-content flex">
  <!-- Left column (1/4 width) - Dates list -->
  <div class="dates-list-container w-1/4 pr-4">
    <!-- Formulario para añadir nuevas fechas -->
    <div class="add-date-form flex items-end mb-4">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Agregar fecha</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="newDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
       <button color="primary" mat-button (click)="addDate()" matTooltip="Agregar Fecha">
                <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
              </button>
      <!-- <button mat-raised-button color="primary" (click)="addDate()" class="ml-2 h-[56px]">
        <mat-icon>add</mat-icon> Añadir
      </button> -->
    </div>

    <!-- Lista de fechas existentes -->
    <div class="existing-dates">
      <h3 class="font-medium mb-2">Fechas programadas:</h3>
      <div class="date-items max-h-[300px] overflow-y-auto">
        <div *ngFor="let dateObj of customDates" class="date-item mb-2">
          <!-- Modo visualización normal -->
          <div *ngIf="selectedDateForEdit?.id !== dateObj.id" class="date-display flex justify-between items-center">
            <span class="text-sm">{{ dateObj.date | date: 'dd/MM/yyyy' }}</span>
            <div class="actions">
              <button mat-icon-button color="primary" (click)="selectDateForEdit(dateObj)" matTooltip="Editar fecha">
                <mat-icon class="text-base">edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="removeDate(dateObj)" matTooltip="Eliminar fecha">
                <mat-icon class="text-base">delete</mat-icon>
              </button>
            </div>
          </div>
          
          <!-- Modo edición -->
          <div *ngIf="selectedDateForEdit?.id === dateObj.id" class="date-edit">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label>Editar fecha</mat-label>
              <input matInput [matDatepicker]="editPicker" [(ngModel)]="selectedDateForEdit.date">
              <mat-datepicker-toggle matSuffix [for]="editPicker"></mat-datepicker-toggle>
              <mat-datepicker #editPicker></mat-datepicker>
            </mat-form-field>
            <div class="edit-actions flex justify-end space-x-2">
              <button mat-button (click)="updateDate()" class="text-sm">Guardar</button>
              <button mat-button (click)="selectedDateForEdit = null" class="text-sm">Cancelar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right column (3/4 width) - Calendar -->
  <div class="calendar-container w-3/4">
    <full-calendar [options]="calendarOptions"></full-calendar>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="start">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <!-- <button mat-raised-button color="primary" (click)="onSave()">Guardar cambios</button> -->
</mat-dialog-actions>